import Field from '@/components/ui/Field';
import SelectField from '@/components/ui/SelectField';
import CheckOption from '@/components/ui/CheckOption';

export default function StepProyecto({ quote, setQuote }) {
  const u = (field, value) =>
    setQuote((q) => ({ ...q, proyecto: { ...q.proyecto, [field]: value } }));

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Datos del proyecto</h2>
      <p className="text-sm text-neutral-500 mb-6">
        Información del desarrollo que vamos a cotizar
      </p>
      <div className="grid grid-cols-2 gap-4">
        <Field
          label="Nombre del proyecto *"
          value={quote.proyecto.nombre}
          onChange={(v) => u('nombre', v)}
          placeholder="Calenna Residencial"
        />
        <SelectField
          label="Tipo"
          value={quote.proyecto.tipo}
          onChange={(v) => u('tipo', v)}
          options={[
            { v: 'residencial-horizontal', l: 'Residencial horizontal' },
            { v: 'residencial-vertical', l: 'Residencial vertical' },
            { v: 'industrial', l: 'Industrial' },
            { v: 'comercial', l: 'Comercial' },
            { v: 'mixto', l: 'Uso mixto' },
            { v: 'lotes', l: 'Lotes / Subdivisión' },
            { v: 'naves', l: 'Naves industriales' },
            { v: 'corporativo', l: 'Corporativo / Oficinas' },
          ]}
        />
        <SelectField
          label="Estatus"
          value={quote.proyecto.estatus}
          onChange={(v) => u('estatus', v)}
          options={[
            { v: 'planeacion', l: 'En planeación' },
            { v: 'preventa', l: 'Preventa' },
            { v: 'construccion', l: 'En construcción' },
            { v: 'terminado', l: 'Terminado' },
          ]}
        />
        <Field
          label="Ubicación"
          value={quote.proyecto.ubicacion}
          onChange={(v) => u('ubicacion', v)}
          placeholder="Santiago, Nuevo León"
        />
        <Field
          label="Número de unidades"
          value={quote.proyecto.unidades}
          onChange={(v) => u('unidades', v)}
          placeholder="106"
        />
        <Field
          label="Superficie"
          value={quote.proyecto.superficie}
          onChange={(v) => u('superficie', v)}
          placeholder="14,900 m²"
        />
      </div>
      <div className="mt-4">
        <label className="text-xs text-neutral-400 uppercase tracking-wider mb-2 block">
          Descripción breve (opcional)
        </label>
        <textarea
          value={quote.proyecto.descripcion}
          onChange={(e) => u('descripcion', e.target.value)}
          rows={3}
          className="w-full px-4 py-2.5 bg-black/40 border border-neutral-800 rounded-lg text-white focus:outline-none focus:border-brand-gold/50 text-sm resize-none"
          placeholder="Concepto, amenidades principales, valor diferenciador..."
        />
      </div>
      <div className="mt-6">
        <label className="text-sm text-white font-medium mb-3 block">
          ¿Qué materiales ya tiene el cliente?
        </label>
        <div className="grid grid-cols-2 gap-3">
          <CheckOption
            checked={quote.proyecto.tieneRenders}
            onChange={(v) => u('tieneRenders', v)}
            label="Renders arquitectónicos"
          />
          <CheckOption
            checked={quote.proyecto.tieneFotos}
            onChange={(v) => u('tieneFotos', v)}
            label="Fotografías del proyecto"
          />
          <CheckOption
            checked={quote.proyecto.tieneModelo3D}
            onChange={(v) => u('tieneModelo3D', v)}
            label="Modelo 3D existente"
          />
          <CheckOption
            checked={quote.proyecto.tieneIdentidad}
            onChange={(v) => u('tieneIdentidad', v)}
            label="Identidad de marca definida"
          />
        </div>
      </div>
    </div>
  );
}
